module.exports = __webpack_public_path__ + "static/media/deactivate.7ecdd27c.svg";